<!--
 * @Author: qinmengyuan
 * @Date: 2024-04-02 10:29:05
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-07-02 18:01:45
 * @FilePath: \onetab\src\components\LoginRegistry.vue
-->
<template>
  <div class="container">
    <div class="avatar">
      <i class="iconfont icon-onetabAvatar"></i>
    </div>
    <RaForm ref="formRef" class="form" :model="form" :rules="rules">
      <RaFormItem prop="email">
        <RaInput ref="emailRef" v-model="form.email" placeholder="邮箱" />
      </RaFormItem>
      <RaFormItem prop="code">
        <RaInput v-model="form.code" :placeholder="'验证码'">
          <template #raAppend>
            <span @click="getCode" :class="{ disabled: data.isSend }">{{
              codeTitle
              }}</span>
          </template>
        </RaInput>
      </RaFormItem>
    </RaForm>
    <!-- <div class="forget-pass">忘记密码</div> -->
    <RaButton @click="handleLogin(formRef)" :loading="data.isLogin">登录</RaButton>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive, nextTick, computed, defineEmits } from 'vue';
import { RaForm, RaFormItem, RaInput, RaButton, RaMessage } from '@rafter/pc';
import { login, sendLoginCode } from '@/api/userApi';
import { getLocalConfig } from '@/utils';
import { user } from '../store/user';
import { syncToLocal, syncToServer } from '@/api/baseApi';
const formRef = ref();
const emailRef = ref();
const form = reactive({ email: '', code: '' });
const isRegistry = ref(false);

const emits = defineEmits(['logged']);

const rules = reactive({
  email: [
    { required: true, message: '请输入邮箱', trigger: 'blur' },
    { type: 'email', message: '邮箱格式错误', trigger: 'blur' },
  ],
  code: [
    { required: true, message: '请输入验证码', trigger: 'blur' },
    { len: 4, message: '验证码位数错误', trigger: 'blur' },
  ],
});

const data = reactive({
  isSend: false,
  codeTitle: '获取验证码',
  countdown: 60,
  isLogin: false,
});

const codeTitle = computed(() => {
  return data.isSend ? `重新发送(${data.countdown})` : '获取验证码';
});

const handleLogin = async (formRef) => {
  await formRef.validate((valid, fields) => {
    if (valid) {
      data.isLogin = true;
      login({ email: form.email, code: Number(form.code) })
        .then((res) => {
          data.isLogin = false;
          if (res.data.code === 200) {
            window['_paq'].push(['trackEvent', '用户', '登录', form.email, 1]);

            localStorage.setItem('onetab_token', res.data.data.access_token);

            // TODO 设置用户信息
            const info = {
              avatar: require('../assets/logo.png'),
              email: form.email,
            };
            localStorage.setItem('onetab_userInfo', JSON.stringify(info));

            user.avatar = info.avatar;
            user.email = info.email;
            user.token = res.data.data.access_token;

            syncToLocal().then(remoteCats => {
              if (remoteCats.length <= 0) {
                syncToServer();
              }
            });

            emits('logged');
          } else {
            RaMessage.error('邮箱或验证码错误');
          }
        })
        .catch(() => {
          data.isLogin = false;
          RaMessage.error('邮箱或验证码错误');
        });
    } else {
      data.isLoading = false;
      console.log('error submit!', fields);
    }
  });
};
onMounted(() => {
  nextTick(() => {
    const token = getLocalConfig('onetab_token');
    emailRef.value.focus();
  });
});
const getCode = () => {
  if (form.email == '') {
    RaMessage.error('请输入邮箱');
    return;
  }

  if (data.isSend) return;
  data.isSend = true;
  data.countdown = 60;

  const timer = setInterval(() => {
    data.countdown--;
    if (data.countdown <= 0) {
      clearInterval(timer);
      data.isSend = false;
    }
  }, 1000);
  sendLoginCode(form.email)
    .then((res) => {
      if (res.data.code === 200) {
        RaMessage.success('发送成功');
      } else {
        RaMessage.error('发送失败');
        clearInterval(timer);
        data.isSend = false;
      }
    })
    .catch((err) => {
      RaMessage.error('发送失败');
      clearInterval(timer);
      data.isSend = false;
    });
};
</script>
<style lang="scss" scoped>
.container {
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .avatar {
    width: 56px;
    height: 56px;
    // margin: 8px;
    // border-radius: 50%;
    // background: $base-bg-color;

    .iconfont {
      font-size: 56px;
      color: #787f8f;
    }
  }

  .form {
    margin-top: 32px;
    width: 320px;
  }

  .forget-pass {
    @include font_color('text-on-surface-tertiary');
    text-align: right;
    font-family: 'PingFang SC';
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    /* 153.846% */
    width: 320px;
    margin-bottom: 20px;
  }

  .ra-button {
    width: 320px;
    margin-bottom: 20px;
  }

  .login-text {
    @include font_color('text-on-surface-tertiary');
    text-align: center;
    font-family: 'PingFang SC';
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    /* 153.846% */
    width: 320px;
    margin-bottom: 20px;
    cursor: pointer;

    .blue {
      color: #007aff;
      font-family: 'PingFang SC';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      /* 153.846% */
      margin-left: 8px;
    }
  }
}

:deep(.ra-append) {
  background-color: var(--field-background-default, #fff);
  box-shadow: 0 0 0 1px var(--field-border-default, #f0f1f4) inset;
  border-radius: 0 6px 6px 0;

  section {
    span {
      font-family: 'PingFang SC';
      font-size: 13px;
      color: var(--text-on-brand-primary, #387ffc);
      padding: 0 12px;
      cursor: pointer;

      &.disabled {
        color: #9b9b9b;
      }
    }
  }
}
</style>
